(() => {
  const selector = '.section-newsletter .has-newsletter-app .asos-newsletter-app';
  const titles = ['Cadastre-se e ganhe até 10% OFF'];
  const descriptions = ['Receba novidades, lançamentos e descontos exclusivos.'];
  const clean = value => (value || '').replace(/\s+/g, ' ').trim();
  const seen = new WeakSet();
  function hideDuplicates(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('h1,h2,h3,h4,p').forEach(node => {
      const txt = clean(node.textContent);
      if (!titles.includes(txt) && !descriptions.includes(txt)) return;
      if (node.children.length && Array.from(node.children).some(c => ['INPUT','BUTTON','SELECT'].includes(c.tagName))) return;
      node.style.setProperty('display', 'none', 'important');
      node.setAttribute('aria-hidden','true');
      const parent = node.parentElement;
      if (parent && !parent.querySelector('input,button,select,textarea,form')) {
        const copy = clean(parent.textContent);
        const copyOnly = [...titles, ...descriptions].includes(copy) || titles.some(title => descriptions.some(description => copy === title + ' ' + description));
        if (copyOnly && !parent.hasAttribute('data-asos-copy-spacing')) {
          parent.setAttribute('data-asos-copy-spacing', '');
          const style = document.createElement('style');
          style.textContent = '@media(max-width:767px){[data-asos-copy-spacing]{display:none!important;margin:0!important;padding:0!important;min-height:0!important}}';
          const scope = parent.getRootNode();
          (scope instanceof ShadowRoot ? scope : document.head).appendChild(style);
        }
      }
    });
  }
  function scan() {
    document.querySelectorAll(selector).forEach(host => {
      hideDuplicates(host);
      host.querySelectorAll('*').forEach(el => {
        if (!el.shadowRoot) return;
        hideDuplicates(el.shadowRoot);
        if (!seen.has(el.shadowRoot)) {
          seen.add(el.shadowRoot);
          new MutationObserver(() => hideDuplicates(el.shadowRoot))
            .observe(el.shadowRoot, { childList: true, subtree: true });
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true});
  else scan();
  let scanScheduled = false;
  const scheduleScan = () => { if (scanScheduled) return; scanScheduled = true; requestAnimationFrame(() => { scanScheduled = false; scan(); }); };
  new MutationObserver(scheduleScan).observe(document.documentElement, {childList:true,subtree:true});
})();